import { PageWrapper, TileContainer } from "@/components";
import { FormType, GUTTER_SIZE } from "@/enums";
import { routes } from "@/helpers";
import { faBlockQuote } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "antd";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Tile, TileTitle } from "./styled";

export const FormSelection = () => {
  const navigate = useNavigate();
  const intl = useIntl();

  const tileConfig = useMemo(
    () => [
      {
        icon: <FontAwesomeIcon icon={faBlockQuote} size="2xl" />,
        title: intl.formatMessage({ id: "formSelection.intakeForm" }),
        link: routes.admin.forms.get(FormType.Intake.toLowerCase()),
      },
    ],
    [intl.locale]
  );

  const tiles = useMemo(
    () =>
      tileConfig.map(({ link, icon, title }, index) => (
        <Col
          key={`tile-${index}`}
          xs={24}
          sm={12}
          md={12}
          lg={8}
          xl={6}
          xxl={5}
        >
          <Tile
            data-test-id="form-selection-tile-link"
            onClick={() => navigate(link)}
          >
            {icon}
            <TileTitle>{title}</TileTitle>
          </Tile>
        </Col>
      )),
    [navigate, tileConfig]
  );

  return (
    <PageWrapper
      pageTitle={intl.formatMessage({ id: "formSelection.pageTitle" })}
      noStyle
    >
      <TileContainer>
        <Row gutter={GUTTER_SIZE.large}>{tiles}</Row>
      </TileContainer>
    </PageWrapper>
  );
};
